import { useEffect } from 'react';

import { useSocketStore } from '../../stores/useSocketStore';
import { useMapStore } from '../../stores/map/useMapStore';
import { usePontosOperacionaisStore } from '../../stores/usePontosOperacionaisStore';

import { loadPontosOperacionais } from '../../services/pontosOperacionaisService';

export function usePontosOperacionaisSocket() {

    const socket = useSocketStore(state => state.socket);

    const openMap = useMapStore(state => state.openMap);

    // =========================
    // SOCKET
    // =========================

    useEffect(() => {

        if (!socket) {
            return;
        }

        const handleUpserted = (ponto) => {

            usePontosOperacionaisStore
                .getState()
                .upsertPontoOperacional(
                    ponto
                );
        };

        const handleDeleted = ({ ID }) => {

            usePontosOperacionaisStore
                .getState()
                .removePontoOperacional(
                    ID
                );
        };

        const handleConnect = () => {

            const { loaded } = usePontosOperacionaisStore.getState();

            // Se já havia carregado anteriormente,
            // reconcilia após a reconexão.
            if (loaded) {

                void loadPontosOperacionais(socket);
            }
        };

        socket.on('pontoOperacional:upserted', handleUpserted);

        socket.on('pontoOperacional:deleted', handleDeleted);

        socket.on('connect', handleConnect);

        return () => {

            socket.off('pontoOperacional:upserted', handleUpserted);

            socket.off('pontoOperacional:deleted', handleDeleted);

            socket.off( 'connect', handleConnect);
        };

    }, [socket]);

    // =========================
    // LOAD
    // =========================

    useEffect(() => {

        if (
            !socket?.connected ||
            !openMap
        ) {
            return;
        }

        const { loaded } = usePontosOperacionaisStore.getState();

        if (loaded) {
            return;
        }

        void loadPontosOperacionais(socket);

    }, [
        socket,
        openMap
    ]);
}